import React, { Fragment, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Carousel } from '../carousel/Carousel'
import { InnerHtml } from '../global'
import { useIsMobileView } from '../../utils'

const PostSlideshow = ({ slideshow, style }) => {
  const [showLightbox, setShowLightbox] = useState(false)
  const lightboxRef = useRef(null)

  const openLightbox = index => {
    lightboxRef.current.slickGoTo(index, true)
    setShowLightbox(true)
  }

  const lightboxClass = classNames('post-lightbox', {
    show: showLightbox,
    hide: !showLightbox,
  })

  const isMobileView = useIsMobileView()

  const setSlideshowClass = idx =>
    classNames('slideshow-image', { first: idx === 0 })

  const generateSlideshowImages = data =>
    data.map(({ image: { altText, sourceUrl, description } }, idx) => (
      <div
        className={setSlideshowClass(idx)}
        key={idx}
        onClick={() => openLightbox(idx)}
        onKeyDown={() => openLightbox(idx)}
        role="button"
        tabIndex={0}
        aria-label="open lightbox"
      >
        <img alt={altText || 'slideshow image'} src={sourceUrl} />
        <div className="image-details">
          {description && (
            <InnerHtml className="image-caption" content={description} />
          )}
        </div>
      </div>
    ))

  // filter out if image is null
  const filteredSlideshow = slideshow.filter(e => e.image)

  if (!filteredSlideshow.length) return null

  const slideshowImages = generateSlideshowImages(filteredSlideshow)

  return (
    <Fragment>
      <div className="post-slideshow" style={style}>
        {slideshowImages.slice(0, 1)}
        <Carousel
          data={slideshowImages.slice(1)}
          autoplay
          gradiant={{ show: !isMobileView, color: 'white' }}
          settings={{
            arrows: !isMobileView,
            swipeToSlide: true,
            slidesToShow: 3,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                },
              },
            ],
          }}
        />
      </div>
      <div className={lightboxClass} style={style}>
        <div
          className="overlay"
          onClick={() => setShowLightbox(false)}
          onKeyDown={() => setShowLightbox(false)}
          role="button"
          tabIndex={0}
          aria-label="close lightbox"
        />
        <Carousel
          data={slideshowImages}
          autoplay
          gradiant={{ show: false }}
          settings={{
            arrows: true,
            swipeToSlide: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            ref: lightboxRef,
            speed: 750,
            responsive: [
              {
                breakpoint: 454,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  touchMove: false,
                },
              },
            ],
          }}
        />
      </div>
    </Fragment>
  )
}

PostSlideshow.propTypes = {
  slideshow: PropTypes.arrayOf(
    PropTypes.shape({ altText: PropTypes.string, sourceUrl: PropTypes.string }),
  ),
  style: PropTypes.object,
}

export default PostSlideshow
